<h1>
  Caixa Design System
</h1>

<button
  class="cds-button s-solid c-primary w-stretch"
  (click)="initLogin()"
>
  Gerar token
</button>

<button class="c-primary cds-button s-hollow w-stretch">
  Teste
</button>

<fieldset>
  <label> Label do input </label>
  <input type="text" class="cds-form-field">
</fieldset>

<section class="cds-input-wrapper">
  <input
    [class]="'cds-radio'"
    [type]="'radio'"
    [name]="'radio'"
    [id]="'radio'"
  />
  <label [for]="'radio'">Radio label</label>
</section>

<section class="cds-input-wrapper">
  <input
    [class]="'cds-checkbox'"
    [type]="'checkbox'"
    [id]="'checkbox'"
  />
  <label [for]="'checkbox'">Label do checkbox</label>
</section>

<fieldset>
  <label>Label do dropdown</label>
  <cds-dropdown
    [options]="['Option 1', 'Option 2', 'Option 3']"
  />
</fieldset>

<fieldset>
  <label>Label do datepicker</label>
  <cds-datepicker placeholder="DD/MM/AAAA"/>
</fieldset>

<div class="icon-row">
  <i class="cds-icon-list"></i>
  <i class="cds-icon-download"></i>
  <i class="cds-icon-pencil"></i>
  <i class="cds-icon-trash"></i>
  <i
    class="cds-icon-calendar"
    [cdsTooltip]="'Última atualização em 06/05/2024 12:34:50'"
    placement="end"
  ></i>
  <i
    class="cds-icon-search"
    [cdsTooltip]="'Última atualização em 06/05/2024 12:34:50'"
    placement="bottom"
  ></i>
  <i
    class="cds-icon-filter"
    [cdsTooltip]="'Última atualização em 06/05/2024 12:34:50'"
    placement="top"
  ></i>
  <i
    class="cds-icon-filled-question"
    [cdsTooltip]="'Saldo disponível consolidado das suas contas Caixa e demais contas correntes conectadas via Open Finance.'"
    placement="start"
  ></i>
</div>
